import FontFaceObserver from 'fontfaceobserver';
import SessionStorage from 'sessionstorage';

export default class FontsLoader {
  constructor(config) {
    this.config = config;
  }

  load() {
    const fontsPromises = this.config
      .map(({family, weight = null, style = null}) => new FontFaceObserver(family, {weight, style}).load());

    return Promise.all(fontsPromises)
      .then(() => {
        document.documentElement.classList.add('fonts-loaded');
        SessionStorage.setItem('fontsLoaded', 'true');
      })
      .catch(() => {
        SessionStorage.setItem('fontsLoaded', 'false');
      });
  }
}
